// extracted by mini-css-extract-plugin
export default {"favorites":"FavoritesList_favorites__R7q3o"};